export { AppError, createAppError, isAppError } from "./app-error";
export {
  buildCacheMeta,
  buildErrorTags,
  buildMutationMeta,
  buildRateLimitKey,
  buildSupabaseErrorTags,
  buildSupabaseRateLimitKey,
  classifyReactQueryError,
  classifySupabaseError,
  detectOrigin,
  getReportOverride,
  shouldRateLimit,
} from "./classifiers";
export { toSentryLevel } from "./levels";
export { normalizeError } from "./normalize";
export { reportError } from "./report";
export {
  AUTH_ERROR_REPORTING_LEVEL_MAP,
  getHttpStatusFromSupabase,
  isFunctionsHttpError,
  isPostgrestError,
  isSupabaseAuthError,
  isSupabaseErrorLike,
  localizeSupabaseError,
  normalizeSupabaseError,
} from "./supabase";
